var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProductShowcaseOutlined(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 1280",
    style: {
      enableBackground: "new 0 0 1280 1280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#5B6673;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1280,
    height: 1280
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M992,128H96c-17.7,0-32,14.3-32,32v640c0,17.7,14.3,32,32,32h896c17.7,0,32-14.3,32-32V160 C1024,142.3,1009.7,128,992,128z M128,768V664.8l254.3-254.3L739.8,768H128z M960,768H830.3l-84.8-84.8L960,576V768z M704,640v1.7 L404.9,342.6c-12.5-12.5-32.8-12.5-45.3,0c0,0,0,0,0,0L128,574.3V192h832v320L704,640z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M952,1088h-90.1c6.9-42.3,10.2-85.1,10.1-128c0-21.3-0.9-42.8-2.8-64h-64.3c2,21.2,3.1,42.7,3.1,64 c0,40.2-3.8,86-10.5,128H712c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8h240c4.4,0,8-3.6,8-8v-48C960,1091.6,956.4,1088,952,1088z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1206.8,565.1c-35.8-22.8-76.5-36.6-118.8-40.1v64.2c21.5,2.5,42.4,8.4,62,17.6c8.8,64.3-14.4,128.8-62,172.8 v79.8c49.7-29.5,90.2-75.9,112.1-135.9C1218.7,672.7,1221.1,617.3,1206.8,565.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductShowcaseOutlined);
export default __webpack_public_path__ + "static/media/productShowcaseOutlined.480f1acae501b0efed6cde69183081c2.svg";
export { ForwardRef as ReactComponent };